module.exports = {
	"UserPoolId": "us-west-2_Uq3Y56PTa",
	"ClientId": "7mvl40lg78ho3rcps15vq35gsu"
};


//////////////////
// WEBPACK FOOTER
// ./cognito-pool-data.json
// module id = 184
// module chunks = 0